import React from 'react';
import { OveitIcon } from '../OveitIcon';

interface CartStepProps {
  status: 'completed' | 'current' | 'next';
  name: string;
  stepNumber: number;
  isFinalStep?: boolean;
}

const CartStep: React.FC<CartStepProps> = ({
  status,
  name,
  stepNumber,
  isFinalStep,
}) => {
  const returnedElement = () => {
    switch (status) {
      case 'completed':
        return (
          <>
            <div className="flex items-center justify-center h-[28px] w-[28px] rounded-full bg-primary">
              <OveitIcon size={14} name="solidWhiteCheck" />
            </div>
            <p className="p1-medium ml-[8px] text-primary"> {name} </p>
            {!isFinalStep && (
              <>
                <hr className="w-[100px] ml-[8px] h-[2px] bg-primary hidden md:block" />
                <div className="h-[10px] w-[2px] bg-primary absolute left-[14px] bottom-[-10px] md:hidden" />
              </>
            )}
          </>
        );
      case 'current':
        return (
          <>
            <div className="flex items-center justify-center h-[28px] w-[28px] rounded-full bg-neutral-1000 text-neutral-10">
              {stepNumber}
            </div>
            <p className="p1-medium ml-[8px] text-neutral-1000"> {name} </p>
            {!isFinalStep && (
              <>
                <hr className="w-[100px] ml-[8px] h-[2px] bg-neutral-1000 hidden md:block" />
                <div className="h-[10px] w-[2px] bg-neutral-1000 absolute left-[14px] bottom-[-10px] md:hidden" />
              </>
            )}
          </>
        );
      case 'next':
        return (
          <>
            <div className="flex items-center justify-center h-[28px] w-[28px] rounded-full border-[1px] border-neutral-600 text-neutral-600">
              {stepNumber}
            </div>
            <p className="p1-medium ml-[8px] text-neutral-600"> {name} </p>
            {!isFinalStep && (
              <>
                <hr className="w-[100px] ml-[8px] h-[2px] bg-neutral-600 hidden md:block" />
                <div className="h-[10px] w-[2px] bg-neutral-600 absolute left-[14px] bottom-[-10px] md:hidden" />
              </>
            )}
          </>
        );
    }
  };
  return (
    <div className="cart-step relative flex items-center mb-[10px] last:mb-0 md:mb-0">
      {returnedElement()}
    </div>
  );
};

export default CartStep;
